import React, { Component } from "reactn";
import { DialogTitle, DialogActions } from "@material-ui/core";
import { Button, TextField } from "@material-ui/core";
import { BeautifulDialog, DialogContent, ShowWarningDialog } from "js/react/components/Dialogs/BaseDialog";

export default class InputDialog extends Component {
    constructor(props) {
        super(props);

        this.state = {
            value: props.value || ""
        };
    }

    handleKeyPress = event => {
        if (event.key == "Enter") {
            this.handleOk();
        }
    }

    handleChange = event => {
        let { maxChars } = this.props;

        let str = event.target.value;
        if (maxChars) {
            str = str.substring(0, maxChars);
        }

        this.setState({ value: str });
    }

    handleCancel = () => {
        this.props.onClose(false);
        this.props.closeDialog();
    }

    handleOk = () => {
        let { allowBlank = false, trimInput = true } = this.props;
        let { value } = this.state;

        if (trimInput) {
            value = value.trim();
        }

        if (!allowBlank && value == "") {
            return ShowWarningDialog({ title: "Input can not be blank" });
        }

        this.props.onClose(value);
        this.props.closeDialog();
    }

    render() {
        const { cancelLabel = "Cancel", okLabel = "Ok" } = this.props;
        const { value } = this.state;

        return (
            <BeautifulDialog
                preventClose
                closeDialog={this.props.closeDialog}
            >
                <DialogTitle>{this.props.title}</DialogTitle>
                <DialogContent>
                    <TextField label={this.props.label}
                        id="dialog-input"
                        value={value}
                        fullWidth
                        autoFocus
                        onKeyPress={this.handleKeyPress}
                        onChange={this.handleChange}
                    />
                </DialogContent>
                <DialogActions>
                    <Button onClick={this.handleCancel}>{cancelLabel}</Button>
                    <Button onClick={this.handleOk}>{okLabel}</Button>
                </DialogActions>
            </BeautifulDialog>
        );
    }
}
